import React, {ReactNode, useContext} from "react";
import {useAppSelector} from "../../app/hooks";
import {AuthResult} from "../../services/AuthService";
import {authState} from "./AuthSlice";
import {AuthState} from "./AuthState";

interface AuthenticationProviderProps {
  children: ReactNode;
}

interface AuthContext {
  authResult: AuthResult | null;
}
const Context = React.createContext<AuthContext>(null!);

const AuthenticationProvider = (props: AuthenticationProviderProps): JSX.Element => {
  const state: AuthState | null = useAppSelector(authState);
  const authResult: AuthResult | null = state ? state.authResult : null;

  return <Context.Provider value={{authResult}}>{props.children}</Context.Provider>;
};

export default AuthenticationProvider;

export const useAuth = (): AuthContext => {
  return useContext(Context);
};
